import React, { useState } from 'react';
import { FaUserAlt, FaEnvelope, FaLock, FaBirthdayCake, FaPhone, FaCheck, FaWonSign, FaUserGraduate } from 'react-icons/fa';
import DragNDrop from '../../Components/Forms/DragnDrop';
import api from '../../api/api';
import { Oval } from 'react-loader-spinner';
import AlertMessage from '../../Components/AlertMessage';

const CreateUser = () => {


  const [data, setData] = useState({
    firstname : null,
    lastname : null,
    password : null,
    confirmedPassword : null,
    phone : null,
    email : null,
    isVerified : false,
    // isOwner : false,
    picture : null
  })

  const [onCreating, setOnCreating] = useState(false);
  const [error, setError] = useState(false);
  const [message, setMessage] = useState('');



  const onCreate = async ()=>{

    try{

      
      if((data.confirmedPassword === data.password) && (data.email && data.firstname && data.lastname && data.phone)){
          
        setOnCreating(true)
        console.log(data)
        // const formData = new FormData();
        // formData.append('password', data.confirmedPassword)
        // formData.append('email', data.email)
        // formData.append('firstname', data.firstname)
        // formData.append('lastname', data.lastname)
        // formData.append('phone', data.phone)
        // formData.append('isVerified', data.isVerified)

        // if (data.picture) {
        //   const uriParts = data.picture.split('.');
        //   const fileType = uriParts[uriParts.length - 1];
    
        //   formData.append('picture', {
        //     uri: data.picture,
        //     name: `photo.${fileType}`,
        //     type: `image/${fileType}`,
        //   });

        //   console.log(formData)
        // }
      

        
        const a = await api.post('/clients/create', data);
        console.log('okokok')


        console.log(a.data)
        setOnCreating(false)
          
          

      }else{

          setError(true)
          setMessage('Entrez toutes les informations')
          
      }

        setOnCreating(false)
        return;

    }catch(e){

      setError(true)
      setMessage("Quelque chose s'est mal passée")
      setOnCreating(false)
      console.log(e)


    }
  }
  

  
  return (
    <div>
      <div className="flex items-center justify-center min-h-screen ">
        <div className="w-full max-w-lg p-8 transition-transform duration-300 ease-in-out transform bg-white rounded-lg shadow-lg dark:bg-gray-800 hover:scale-x-110">
          <h2 className="mb-6 text-2xl font-bold text-center text-gray-800 dark:text-white">
            Créer un compte
          </h2>
          <form>
            {/* <DragNDrop
              picture={data.picture}
              setPicture={(pic)=>{
                setData((tada)=>
                  ({
                    ...tada,
                    picture : pic
                  })
                )
              }}
            /> */}

            <div className="my-4">
              <label className="block mb-2 text-gray-600 dark:text-gray-300">
                Nom
              </label>
              <div className="flex items-center px-4 py-2 bg-gray-200 rounded-lg dark:bg-gray-700">
                <FaUserAlt className="text-gray-400 dark:text-gray-300" />
                
                <input
                  type="text"
                  placeholder="Entrez votre nom"
                  className="w-full ml-2 text-gray-800 bg-transparent border-0 rounded-lg dark:text-gray-100"
                  onChange={(event)=>{
                    setData((prev)=>(
                      {
                        ...prev,
                        lastname : event.target.value
                      }
                    ))
                  }}
                />
              </div>
            </div>
            <div className="mb-4">
              <label className="block mb-2 text-gray-600 dark:text-gray-300">
                Prénom
              </label>
              <div className="flex items-center p-2 bg-gray-200 rounded dark:bg-gray-700">
                <FaUserAlt className="text-gray-400 dark:text-gray-300" />
                <input
                  type="text"
                  placeholder="Entrez votre prénom"
                  className="w-full ml-2 text-gray-800 bg-transparent border-0 rounded-lg dark:text-gray-100"
                  onChange={(event)=>{
                    setData((prev)=>(
                      {
                        ...prev,
                        firstname : event.target.value
                      }
                    ))
                  }}
                />
              </div>
            </div>
            <div className="mb-4">
              <label className="block mb-2 text-gray-600 dark:text-gray-300">
                Telephone
              </label>
              <div className="flex items-center p-2 bg-gray-200 rounded dark:bg-gray-700">
                <FaPhone className="text-gray-400 dark:text-gray-300" />
                <input
                  type="text"
                  placeholder='Telephone'
                  className="w-full ml-2 text-gray-800 bg-transparent border-0 rounded-lg dark:text-gray-100"
                  onChange={(event)=>{
                    setData((prev)=>(
                      {
                        ...prev,
                        phone : event.target.value
                      }
                    ))
                  }}
                />
              </div>
            </div>
            <div className="mb-4">
              <label className="block mb-2 text-gray-600 dark:text-gray-300">
                Email
              </label>
              <div className="flex items-center p-2 bg-gray-200 rounded dark:bg-gray-700">
                <FaEnvelope className="text-gray-400 dark:text-gray-300" />
                <input
                  type="email"
                  placeholder="Entrez votre email"
                  className="w-full ml-2 text-gray-800 bg-transparent border-0 rounded-lg dark:text-gray-100"
                  onChange={(event)=>{
                    setData((prev)=>(
                      {
                        ...prev,
                        email : event.target.value
                      }
                    ))
                  }}
                />
              </div>
            </div>
            <div className="mb-6">
              <label className="block mb-2 text-gray-600 dark:text-gray-300">
                Mot de passe
              </label>
              <div className="flex items-center p-2 mb-4 bg-gray-200 rounded dark:bg-gray-700">
                <FaLock className="text-gray-400 dark:text-gray-300" />
                <input
                  type="password"
                  placeholder="Entrez votre mot de passe"
                  className="w-full ml-2 text-gray-800 bg-transparent border-0 rounded-lg dark:text-gray-100"

                    onChange={(event)=>{
                      setData((prev)=>(
                        {
                          ...prev,
                          password : event.target.value
                        }
                      ))
                    }}
                />
              </div>


              <div className="flex items-center p-2 mb-4 bg-gray-200 rounded dark:bg-gray-700">
                <FaLock className="text-gray-400 dark:text-gray-300" />
                <input
                  type="password"
                  placeholder="confirmer votre mot de passe"
                  className="w-full ml-2 text-gray-800 bg-transparent border-0 rounded-lg dark:text-gray-100"

                    onChange={(event)=>{
                      setData((prev)=>(
                        {
                          ...prev,
                          confirmedPassword : event.target.value
                        }
                      ))
                    }}
                />
              </div>
            </div>

          
            <div className="flex items-center px-2 py-4 mb-4 bg-gray-200 rounded dark:bg-gray-700">
                <FaCheck className="text-gray-400 dark:text-gray-300" />
                <input
                  id='isValid'
                  type="checkbox"
                  checked={data.isVerified}
                  className="ml-2 text-indigo-600 bg-gray-200 border-0 rounded-lg"
                  onClick={(event)=>{
                      setData((prev)=>(
                        {
                          ...prev,
                          isVerified : !data.isVerified
                        }
                      ))
                    }}
                />
                <label id='isValid' className='mx-2 text-sm text-gray-500'>
                  Valider l'utilisateur
                </label>
            </div>

            {/* <div className="flex items-center px-2 py-4 mb-4 bg-gray-200 rounded dark:bg-gray-700">
                <FaUserGraduate className="text-gray-400 dark:text-gray-300" />
                <input
                  id='isValid'
                  type="checkbox"
                  checked={data.isOwner}
                  className="ml-2 text-indigo-600 bg-gray-200 border-0 rounded-lg"

                    onClick={(event)=>{
                      setData((prev)=>(
                        {
                          ...prev,
                          isOwner : !data.isOwner
                        }
                      ))
                    }}
                />
                <label id='isValid' className='mx-2 text-sm text-gray-500'>
                  Est proprietaire
                </label>
            </div> */}
            {error && <AlertMessage message={message} type={'error'} onClose={()=>setError(false)}/>}
              
           {!onCreating && <div
              
              className="flex items-center justify-center px-4 py-3 text-white transition-all duration-500 bg-indigo-800 rounded-lg shadow-md cursor-pointer hover:bg-indigo-600 hover:ring-4 ring-indigo-400"
              onClick={()=>onCreate()}
              
            >
              Créer
            </div>}

            {onCreating && <div className="flex items-center justify-center px-4 py-3 text-white transition-all duration-500 rounded-lg cursor-wait ">
              <Oval
                height={20}
                width={20}
                color="#ffffff"
                visible={true}
                ariaLabel="oval-loading"
                secondaryColor="#cccccc"
                strokeWidth={2}
                strokeWidthSecondary={2}
              />

            </div>}
          </form>
          
        </div>
      </div>
    </div>
  );
};

export default CreateUser;
